import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, interval, merge, Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdleTimerService {
  private idleTimeout = environment.activityLogoutTimeInMins * 60 * 1000;
  private activityEvents = ['mousemove', 'keydown', 'click'];
  private activitySubscription?: Subscription;
  private idleTimer?: Subscription;
  private countdownInterval?: Subscription;

  public remainingSeconds: number = this.idleTimeout / 1000;

  constructor(
    private ngZone: NgZone,
    private router: Router
  ) { }

  startWatching(logoutCb: () => void) {
    this.ngZone.runOutsideAngular(() => {
      this.activitySubscription = merge(
        ...this.activityEvents.map((ev) => fromEvent(document, ev))
      ).subscribe(() => this.resetTimer(logoutCb));
    });

    this.resetTimer(logoutCb);
  }

  stopWatching() {
    this.activitySubscription?.unsubscribe();
    this.idleTimer?.unsubscribe();
    this.countdownInterval?.unsubscribe();
  }

  private resetTimer(logoutCb: () => void) {
    this.idleTimer?.unsubscribe();
    this.countdownInterval?.unsubscribe();
    this.remainingSeconds = this.idleTimeout / 1000;

    if (!environment.production) {
      this.countdownInterval = interval(1000).subscribe(() => {
        this.remainingSeconds--;
        //console.log('⏳ Idle countdown:', this.remainingSeconds, 'seconds');
        if (this.remainingSeconds <= 0) {
          this.countdownInterval?.unsubscribe();
        }
      });
    }

    this.idleTimer = timer(this.idleTimeout).subscribe(() => {
      this.ngZone.run(() => {
        console.log('🚪 Inactive for 10 minutes → Logging out...');
        logoutCb();
      });
    });
  }
}
